import { render, staticRenderFns } from "./DepositsReport.vue?vue&type=template&id=bafe0458"
import script from "./DepositsReport.vue?vue&type=script&lang=js"
export * from "./DepositsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports